import { useState } from "react";
import AlphaCashFreeLinks from "../CashfreePaymentLinkCreation/AlphaCashFreeLinks";
import FinanceOrderApprovals from "./FinanceOrderApprovals";

/// Two independent approval queues under one tab:
///  - payment: Alpha prepaid transaction approvals (alpha_transactions)
///  - order:   Finance-pending order-booking sales orders (booking_slots.status = 2)
/// Each sub-view is self-contained (own fetch/pagination/actions); this wrapper only
/// owns the switch. Both are kept mounted-on-demand so switching starts each fresh.
const TABS = [
  { key: "payment", label: "Alpha Payment Approvals" },
  { key: "order", label: "Sales Order Approvals" },
];

const PaymentOrderApprovals = () => {
  const [active, setActive] = useState("payment");

  return (
    <div className="w-full max-w-full overflow-x-hidden">
      <div className="flex items-center gap-2 border-b border-gray-200 px-4 pt-4">
        <div className="inline-flex rounded-lg bg-gray-100 p-1">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => setActive(t.key)}
              aria-pressed={active === t.key}
              className={`rounded-md px-4 py-1.5 text-sm font-medium transition-colors ${
                active === t.key ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-700"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {active === "payment" ? <AlphaCashFreeLinks /> : <FinanceOrderApprovals />}
    </div>
  );
};

export default PaymentOrderApprovals;
